import { useIsDesktop } from '../../hooks'
import { UI_DropdownMenu } from './ui_dropdown-menu'
import { UI_Drawer, onCloseDrawer } from '../drawer'

function UI_DropdownDrawer({
  children,
  items,
  cancelButtonLabel = 'cancel',
  ...props
}: {
  children: React.ReactNode
  items: {
    label: string | React.ReactNode
    icon?: React.ReactNode
    onClick: React.MouseEventHandler<HTMLDivElement>
  }[]

  cancelButtonLabel?: string
  open?: boolean
  onOpenChange?: (open: boolean) => void
}) {
  const isDesktop = useIsDesktop()

  return isDesktop ? (
    <UI_DropdownMenu items={items} {...props}>
      {children}
    </UI_DropdownMenu>
  ) : (
    <UI_Drawer items={items} cancelButtonLabel={cancelButtonLabel}>
      {children}
    </UI_Drawer>
  )
}

export { UI_DropdownDrawer, onCloseDrawer }
